/**
 * Shared date range utilities for admin panel
 * Used in AddPrivateTour, AddGroupTour, etc.
 * Preserves all business logic exactly
 */

import { addDays, format } from 'date-fns';

export const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    try {
        return format(new Date(dateStr), 'MMM d, yyyy');
    } catch {
        return String(dateStr);
    }
};

export const createNewDateRange = (existingDates, isUnavailable = false) => {
    const count = Object.keys(existingDates).length;
    const newDates = { ...existingDates };
    
    const newRange = {
        startDate: addDays(new Date(), 0),
        endDate: addDays(new Date(), 0),
        key: 'selection' + (count + 1),
    };
    
    if (isUnavailable) {
        newRange.color = 'brown';
    }
    
    newDates[`selection${count + 1}`] = newRange;
    return newDates;
};

export const removeLastDateRange = (existingDates) => {
    const dates = { ...existingDates };
    const keys = Object.keys(dates);
    const lastKey = keys.pop();
    
    if (lastKey) {
        delete dates[lastKey];
    }
    
    return dates;
};

export const convertDateRangesToArray = (dateRanges) => {
    const data = [];
    for (let key in dateRanges) {
        data.push(dateRanges[key]);
    }
    return data;
};
